import script from "./TextField.vue?vue&type=script&setup=true&lang=js"
export * from "./TextField.vue?vue&type=script&setup=true&lang=js"

import "./TextField.vue?vue&type=style&index=0&id=1b99e2f0&scoped=true&lang=css"

import exportComponent from "/home/dragos/Work/cozmoslabs-ddev/translatepress/wp-content/plugins/translatepress/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b99e2f0"]])

export default __exports__